import {
  client,
} from "../client/client.gen";
import {
  automaticApprovalsStatusApiV1AutomaticApprovalsGet,
  signOutEverywhereApiV1AuthLogoutEverywherePost,
  dedicatedNumberStatusApiV1DedicatedNumberGet,
  downloadContactCardApiV1DedicatedNumberContactCardGet,
  getContactTextingConsentApiV1ContactTextingGet,
  provisionNumberApiV1DedicatedNumberPost,
  releaseNumberApiV1DedicatedNumberDelete,
  rotateKeyApiV1ShortcutKeyRotatePost,
  setAutonomyLevelApiV1AutomaticApprovalsLevelPut,
  setContactTextingConsentApiV1ContactTextingPut,
  shortcutStatusApiV1ShortcutGet,
} from "../client";
import type {
  AutomaticApprovalsStatus,
  AutonomyLevel,
  CountryOption,
  ShortcutStatus,
} from "../client";
import {
  getCurrentUserApiV1AuthMeGet,
  getUserAssistantCharacterApiV1AuthMeAssistantGet,
  listAssistantCharactersApiV1AuthCharactersGet,
  createCustomCharacterApiV1AuthCharactersCustomPost,
  deleteCustomCharacterApiV1AuthCharactersCustomDelete,
  uploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePost,
  revertCustomCharacterPictureApiV1AuthCharactersCustomPictureDelete,
  listCharacterVoicesApiV1AuthCharactersVoicesGet,
  updateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePut,
  updateUserAssistantCharacterApiV1AuthMeAssistantPut,
  updateUserAssistantNameApiV1AuthMeAssistantNamePut,
  completeSetupApiV1AuthMeCompleteSetupPost,
  getWhatsappStatusApiV1WhatsappStatusGet,
  generateVerificationCodeApiV1WhatsappGenerateCodePost,
  disconnectWhatsappApiV1WhatsappDisconnectDelete,
  getSmsStatusApiV1SmsStatusGet,
  generateVerificationCodeApiV1SmsGenerateCodePost,
  verifySmsCodeApiV1SmsVerifyCodePost,
  disconnectSmsApiV1SmsDisconnectDelete,
  // iMessage API functions
  getImessageStatusApiV1ImessageStatusGet,
  generateVerificationCodeApiV1ImessageGenerateCodePost,
  disconnectImessageApiV1ImessageDisconnectDelete,
  // Slack API functions
  getSlackStatusApiV1SlackStatusGet,
  initiateSlackOauthApiV1SlackOauthInitiatePost,
  handleSlackOauthCallbackApiV1SlackOauthCallbackPost,
  disconnectSlackApiV1SlackDisconnectDelete,
  // Slack personal (read-only, user token) API functions
  getSlackPersonalStatusApiV1SlackPersonalStatusGet,
  initiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePost,
  handleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPost,
  listSlackPersonalConversationsApiV1SlackPersonalConversationsGet,
  updateSlackPersonalAccessApiV1SlackPersonalAccessPut,
  disconnectSlackPersonalApiV1SlackPersonalDisconnectDelete,
  getTeamsAccessStatusApiV1TeamsAccessStatusGet,
  listTeamsAccessConversationsApiV1TeamsAccessConversationsGet,
  updateTeamsAccessApiV1TeamsAccessPut,
  listMyViewsApiV1ViewsGet,
  getMyViewApiV1ViewsViewIdGet,
  // Email provider detection
  detectEmailProviderEndpointApiV1AuthDetectEmailProviderPost,
  requestSignInHelpApiV1PublicSignInHelpPost,
  type AuthProvider,
  // Connect a personal (secondary) email account
  connectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGet,
  getAddonPricingApiV1AuthConnectEmailAddonPricingGet,
  connectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGet,
  listConnectedEmailAccountsApiV1AuthConnectEmailAccountsGet,
  disconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDelete,
  connectImapInboxApiV1AuthConnectEmailImapPost,
  type ConnectedAccountSummary,
  // Connect a dedicated assistant mailbox (EXTERNAL assistant email)
  connectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGet,
  connectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGet,
  // Scope management
  requestScopesApiV1AuthRequestScopesGet,
  scopeStatusApiV1AuthScopeStatusGet,
  // Billing API functions
  getPricingApiV1BillingPricingGet,
  getSubscriptionStatusApiV1BillingSubscriptionGet,
  checkoutApiV1BillingCheckoutPost,
  getPurchaseCreditsApiV1BillingPurchaseCreditsGet,
  purchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPost,
  portalApiV1BillingPortalPost,
  portalFromSignedLinkApiV1BillingPortalLinkPost,
  applyPromotionCodeApiV1BillingPromotionCodePost,
  // Assistant email API functions
  getAssistantEmailStatusApiV1AssistantEmailGet,
  setAssistantEmailApiV1AssistantEmailPut,
  changeHandleApiV1AssistantEmailHandlePut,
  getDnsInstructionsApiV1AssistantEmailDnsInstructionsGet,
  verifySubdomainApiV1AssistantEmailVerifyPost,
  // Stats API function
  getMyStatsApiV1StatsMeGet,
  type AssistantStatsResponse,
  // Referral API functions
  getReferralLinkApiV1ReferralLinkGet,
  getReferralStatusApiV1ReferralStatusGet,
  getSuggestionsApiV1ReferralSuggestionsGet,
  getNetworkApiV1ReferralNetworkGet,
  dismissContactApiV1ReferralDismissPost,
  getInvitesApiV1ReferralInvitesGet,
  getInvitePreviewApiV1ReferralInvitePreviewGet,
  saveInviteTemplateApiV1ReferralInviteTemplatePut,
  resetInviteTemplateApiV1ReferralInviteTemplateDelete,
  sendInviteApiV1ReferralInvitePost,
  type ReferralLinkResponse,
  type ReferralNetworkResponse,
  type ReferralStatusResponse,
  type ReferralInvitePreviewResponse,
  type ReferralInviteTemplateRequest,
  type SuggestedContact,
  type SentReferralInvite,
  // Types
  type UserResponse,
  type AssistantCharacterResponse,
  type PersonalityTraits,
  type VoiceOption,
  type LoginResponse,
  type WhatsAppStatusResponse,
  type VerificationCodeResponse,
  type WhatsAppDisconnectResponse,
  type SmsStatusResponse,
  type SmsGenerateCodeResponse,
  type SmsVerifyCodeResponse,
  type SmsDisconnectResponse,
  type IMessageStatusResponse,
  type IMessageHandleResponse,
  type IMessageGenerateCodeResponse,
  type IMessageDisconnectResponse,
  type SlackStatusResponse,
  type SlackOAuthInitResponse,
  type SlackOAuthCallbackData,
  type SlackDisconnectResponse,
  type SlackPersonalStatusResponse,
  type SlackPersonalConversationsResponse,
  type SlackPersonalAccessUpdate,
  type SlackPersonalAccessMode,
  type SlackPersonalConversation,
  type TeamsAccessStatusResponse,
  type TeamsAccessConversationsResponse,
  type TeamsAccessUpdate,
  type TeamsAccessMode,
  type AssistantViewIndex,
  type AssistantViewPage,
  type TeamsConversation,
  type DetectEmailProviderResponse,
  type ScopeStatusResponse,
  // Billing types
  type PricingResponse,
  type PurchaseCreditsResponse,
  type SubscriptionResponse,
  type CheckoutResponse,
  type PortalResponse,
  type ApplyPromotionCodeResponse,
  type AppliedDiscount,
  // Assistant email types
  type AssistantEmailStatusResponse,
  type AssistantEmailOption,
  type AssistantMailboxType,
  type PendingSubdomainInfo,
  type ExternalMailboxInfo,
  type DnsInstructionsResponse,
  type VerifyResponse,
  // Webhook types
  type WebhookIntegrationCreate,
  type WebhookIntegrationResponse,
  type WebhookIntegrationUpdate,
  type WebhookIntegrationWithTokenResponse,
  // Integration request
  requestIntegrationApiV1IntegrationsRequestPost,
  type IntegrationRequestResponse,
  type CatalogAppMatch,
  type BuiltInAppMatch,
  // Inbox-scan integration suggestions
  getIntegrationSuggestionsApiV1IntegrationSuggestionsGet,
  dismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPost,
  type IntegrationSuggestionsResponse,
  type IntegrationSuggestionItem,
  // Custom (toolsmith) integrations
  listCustomIntegrationsEndpointApiV1IntegrationsCustomGet,
  deleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDelete,
  createCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPost,
  type CustomIntegrationSummary,
  // Promoted (monty-backed) integrations
  listFeaturedIntegrationsApiV1IntegrationsFeaturedGet,
  listPromotedIntegrationsApiV1IntegrationsPromotedGet,
  ensurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPost,
  disconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDelete,
  type FeaturedIntegrationSummary,
  type PromotedIntegrationSummary,
  type PromotedIntegrationEnsureSpecResponse,
  // Shared (an admin shared another user's custom integration with you)
  listSharedIntegrationsApiV1IntegrationsSharedGet,
  type SharedIntegrationSummary,
  // Generic Pipedream app catalog
  listPipedreamAppsApiV1IntegrationsPipedreamAppsGet,
  listPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGet,
  createGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPost,
  disconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDelete,
  type PipedreamAppCatalogPageResponse,
  type PipedreamAppConnectionResponse,
  // Enterprise organization (team admin board)
  getOrganizationAccessApiV1OrganizationAccessGet,
  getMyOrganizationApiV1OrganizationGet,
  createOrganizationEndpointApiV1OrganizationPost,
  getMembersApiV1OrganizationMembersGet,
  getPendingInvitesApiV1OrganizationInvitesGet,
  createInvitesApiV1OrganizationInvitesPost,
  revokeInviteEndpointApiV1OrganizationInvitesInviteIdDelete,
  getEligibleUsersApiV1OrganizationEligibleUsersGet,
  migrateMembersApiV1OrganizationMembersMigratePost,
  deactivateMemberApiV1OrganizationMembersUserIdDeactivatePost,
  reactivateMemberApiV1OrganizationMembersUserIdReactivatePost,
  promoteMemberEndpointApiV1OrganizationMembersUserIdPromotePost,
  removeMemberEndpointApiV1OrganizationMembersUserIdDelete,
  getOrganizationStatsApiV1OrganizationStatsGet,
  getRedactedEntriesApiV1OrganizationRedactedEntriesGet,
  getTeamSkillsApiV1OrganizationTeamSkillsGet,
  addRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPost,
  removeRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDelete,
  orgBillingCheckoutApiV1OrganizationBillingCheckoutPost,
  orgBillingPortalApiV1OrganizationBillingPortalPost,
  getMyInvitesApiV1OrganizationInvitesMineGet,
  acceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPost,
  declineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePost,
  declineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePost,
  leaveOrganizationEndpointApiV1OrganizationLeavePost,
  type MyInviteResponse,
  type OrganizationAccessResponse,
  type TeamSkillsPageResponse,
  type OrgCheckoutResponse,
  type OrganizationResponse,
  type OrganizationMemberResponse,
  type PendingInviteResponse,
  type InviteBatchResponse,
  type EligibleUserResponse,
  type MigrateBatchResponse,
  type OrganizationStatsResponse,
  type RedactedEntryResponse,
} from "../client";
import {
 isPublicRoute,
 loginPathForRoute
} from "../utils/routes";
import {
 rememberPendingRoute,
} from '../utils/pendingRoute';
import {
  getValidStoredReferralCode,
} from "../utils/referral";
import posthog from 'posthog-js';
import {
  API_BASE_URL,
} from "../config";
import {
 clearSensitiveBrowserState, getStoredSessionIdentity
} from '../utils/browserSession';

export const STRIPE_PUBLISHABLE_KEY: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY || "";

// Configure the base URL for the client
client.setConfig({
  baseURL: `${API_BASE_URL}`,
  withCredentials: true, // Enable sending/receiving cookies for cross-origin requests
});

// Snapshot the request's identity so a late anonymous/old-account response
// cannot clear an account that signed in while that request was in flight.
client.instance.interceptors.request.use((config) => ({
  ...config,
  catchSessionIdentityAtRequest: getStoredSessionIdentity(),
}));

// Add response interceptor to handle 401 errors globally
client.instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentIdentity = getStoredSessionIdentity();
      const requestIdentity = Object.prototype.hasOwnProperty.call(error.config ?? {}, 'catchSessionIdentityAtRequest')
        ? error.config.catchSessionIdentityAtRequest
        : currentIdentity;
      if (requestIdentity !== currentIdentity) return Promise.reject(error);
      // Anonymous probes are expected during sign-in. Their OAuth, referral,
      // checkout and pre-signup choices must survive that round-trip.
      if (requestIdentity !== null) clearSensitiveBrowserState();

      // Only redirect to login if we're not already on a public/auth page
      // This prevents infinite redirect loops when checking auth status
      const currentPath = window.location.pathname;
      if (!isPublicRoute(currentPath)) {
        // The other way a deep link loses its query string, and the one that
        // usually wins the race: on a cold signed-out load this fires while
        // ProtectedRoute is still rendering its loading branch, so the guard's
        // own `rememberPendingRoute` may never run (GET-13956).
        rememberPendingRoute(currentPath, window.location.search);
        window.location.href = loginPathForRoute(
          currentPath,
          window.location.search,
        );
      }
    }
    return Promise.reject(error);
  },
);

/**
 * Extract a human-readable message from a thrown API error.
 *
 * Service methods that pass `throwOnError: true` reject with an AxiosError whose
 * body carries the backend's `{ detail }`. Use this in catch blocks so flows can
 * show the real reason a request failed instead of a generic message — or, worse,
 * a silent no-op that fakes success (see the onboarding character-save incident).
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const detail = (
    err as { response?: { data?: { detail?: unknown } } }
  )?.response?.data?.detail;
  return typeof detail === "string" && detail.trim().length > 0
    ? detail
    : fallback;
}

/**
 * Whether a rejected request carries a `detail` our own handler wrote.
 *
 * A status can be produced by something in front of the app — a load balancer's
 * 502 while the backend crash-loops has an HTML body and no `detail` — so a
 * status test alone cannot tell "our handler ran and reported this" from
 * "something upstream answered for us". Callers that attribute a failure to a
 * specific cause need that distinction: LoginPage only names the customer's
 * identity provider as unreachable when a 502 also came from our handler,
 * because otherwise it blames their IdP for our outage (GET-12701).
 */
export function hasApiErrorDetail(err: unknown): boolean {
  return getApiErrorMessage(err, "") !== "";
}

/**
 * The HTTP status of a rejected `throwOnError: true` request, or `undefined`
 * if it wasn't an HTTP error (network failure, etc.). Lets flows branch on the
 * status (e.g. a 429 rate-cap) rather than string-matching the message.
 */
export function getApiErrorStatus(err: unknown): number | undefined {
  const status = (err as { response?: { status?: unknown } })?.response?.status;
  return typeof status === "number" ? status : undefined;
}

/**
 * What to show the user when a request fails.
 *
 * Only a 4xx carries a `detail` written for a human ("Single sign-on is not
 * configured for this email domain." — routers/auth.py), and only a 4xx is
 * something they can act on. A 5xx's detail is
 * FastAPI's own "Internal Server Error" — showing that verbatim is worse than
 * the generic line, since it reads as the user's fault and suggests nothing to
 * do. A network failure has no response at all. Both take `fallback`.
 *
 * The 4xx test is a WHITELIST, deliberately: every other shape (no status, a
 * 3xx, a proxy's HTML 502) falls through to a string we wrote. Do not invert it
 * into a "not a 5xx" test — that reverses which side of the branch an unknown
 * lands on. (Carried here from LoginPage's local copy, where a review put it.)
 *
 * THE RULE: a string that reaches a user goes through this; `getApiErrorMessage`
 * is for logs and for callers that have already gated on a status themselves.
 *
 * That is not yet how most of the codebase works, and the migration is
 * unfinished rather than decided against. Two families still violate it — find
 * the current offenders rather than trusting a count, which rots silently:
 *
 *   grep -rn 'getApiErrorMessage(' frontend/src   # unguarded ones show a 5xx detail
 *   grep -rn 'extractErrorMessage(' frontend/src  # worse: see below
 *
 * `utils/errors.ts::extractErrorMessage` is the one to check first. It ends
 * `err?.message || fallback`, so on a network failure it renders axios's own
 * "Request failed with status code 500" — the exact string this module's tests
 * assert must never reach a user.
 *
 * Treat that as an unfinished migration, not settled convention. The tempting
 * one-shot fix — fold the guard below into `getApiErrorMessage` itself and
 * delete this function — is WRONG as stated: `hasApiErrorDetail` above is built
 * on `getApiErrorMessage` precisely to read a 5xx `detail`, so guarding it
 * would make LoginPage stop distinguishing "our handler emitted this 502" from
 * "a load balancer did" and silently regress GET-12701. It would also change
 * ~28 user-visible strings at once, and three of those call sites stub this
 * module in their tests, so almost nothing would fail. That is a copy review,
 * not a bugfix (GET-12886).
 */
export function getUserFacingApiErrorMessage(
  err: unknown,
  fallback: string,
): string {
  const status = getApiErrorStatus(err);
  const isClientError = status !== undefined && status >= 400 && status < 500;
  return isClientError ? getApiErrorMessage(err, fallback) : fallback;
}

// Re-export types for easier importing
export type {
  UserResponse as User,
  AssistantCharacterResponse as AssistantCharacter,
  ConnectedAccountSummary,
  IntegrationSuggestionItem,
  IntegrationRequestResponse,
  CatalogAppMatch,
  BuiltInAppMatch,
  WhatsAppStatusResponse,
  VerificationCodeResponse,
  WhatsAppDisconnectResponse,
  SmsStatusResponse,
  SmsGenerateCodeResponse,
  SmsVerifyCodeResponse,
  SmsDisconnectResponse,
  IMessageStatusResponse,
  IMessageHandleResponse,
  IMessageGenerateCodeResponse,
  IMessageDisconnectResponse,
  // Scope types
  ScopeStatusResponse,
  PipedreamAppCatalogPageResponse,
  PipedreamAppConnectionResponse,
  // Slack types
  SlackStatusResponse,
  SlackOAuthInitResponse,
  SlackOAuthCallbackData,
  SlackDisconnectResponse,
  SlackPersonalStatusResponse,
  SlackPersonalConversationsResponse,
  SlackPersonalAccessUpdate,
  SlackPersonalAccessMode,
  SlackPersonalConversation,
  TeamsAccessStatusResponse,
  TeamsAccessConversationsResponse,
  TeamsAccessUpdate,
  TeamsAccessMode,
  TeamsConversation,
  // Billing types
  PricingResponse,
  PurchaseCreditsResponse,
  SubscriptionResponse,
  CheckoutResponse,
  PortalResponse,
  ApplyPromotionCodeResponse,
  AppliedDiscount,
  // Assistant email types
  AssistantEmailStatusResponse,
  AssistantEmailOption,
  AssistantMailboxType,
  PendingSubdomainInfo,
  ExternalMailboxInfo,
  DnsInstructionsResponse,
  VerifyResponse,
  // Webhook types
  WebhookIntegrationResponse,
  WebhookIntegrationWithTokenResponse,
  WebhookIntegrationCreate,
  WebhookIntegrationUpdate,
  // Custom (toolsmith) integrations
  CustomIntegrationSummary,
  PersonalityTraits,
  VoiceOption,
};

// Local convenience types (not in generated SDK)

/** The editable fields of a custom character, as `createCustomCharacter` takes them. */
export interface CustomCharacterDetails {
  name: string;
  bio: string;
  personality_traits: PersonalityTraits;
}

// Zoom types (manual until SDK regeneration)
export interface ZoomStatusResponse {
  connected: boolean;
  zoom_user_id: string | null;
  email: string | null;
}

export interface ZoomOAuthInitResponse {
  oauth_url: string;
  state: string;
}

export interface ZoomOAuthCallbackData {
  code: string;
  state: string;
}

export interface ZoomDisconnectResponse {
  success: boolean;
  message: string;
}

export interface IntegrationStatusResponse {
  connected: boolean;
  external_user_id: string | null;
  connected_at: string | null;
}

export interface IntegrationDisconnectResponse {
  success: boolean;
  message: string;
}

// A single connected instance of an integration type (multi-instance support).
// Mirrors the backend IntegrationInstanceStatus model.
export interface IntegrationInstance {
  id: number;
  label: string;
  connected: boolean;
  external_user_id: string | null;
  connected_at: string | null;
}

export type GranolaStatusResponse = IntegrationStatusResponse & {
  granola_user_id: string | null;
};
export type GranolaDisconnectResponse = IntegrationDisconnectResponse;
export type ClickUpStatusResponse = IntegrationStatusResponse;
export type ClickUpDisconnectResponse = IntegrationDisconnectResponse;
export type AsanaStatusResponse = IntegrationStatusResponse;
export type AsanaDisconnectResponse = IntegrationDisconnectResponse;
export type NotionStatusResponse = IntegrationStatusResponse;
export type NotionDisconnectResponse = IntegrationDisconnectResponse;
export type HubSpotStatusResponse = IntegrationStatusResponse;
export type HubSpotDisconnectResponse = IntegrationDisconnectResponse;
export type AttioStatusResponse = IntegrationStatusResponse;
export type AttioDisconnectResponse = IntegrationDisconnectResponse;
export type SalesforceStatusResponse = IntegrationStatusResponse;
export type SalesforceDisconnectResponse = IntegrationDisconnectResponse;
export type HoneyBookStatusResponse = IntegrationStatusResponse;
export type HoneyBookDisconnectResponse = IntegrationDisconnectResponse;
export type FathomStatusResponse = IntegrationStatusResponse;
export type FathomDisconnectResponse = IntegrationDisconnectResponse;
export type OtterStatusResponse = IntegrationStatusResponse;
export type OtterDisconnectResponse = IntegrationDisconnectResponse;
export type WisprStatusResponse = IntegrationStatusResponse;
export type WisprDisconnectResponse = IntegrationDisconnectResponse;

function createIntegrationService<
  TStatus = IntegrationStatusResponse,
  TDisconnect = IntegrationDisconnectResponse,
>(type: string) {
  return {
    async getStatus(): Promise<TStatus> {
      const response = await client.get({
        url: `/api/v1/integrations/${type}/status`,
      });
      return response.data as TStatus;
    },

    // List every connected instance (account) of this integration type. Drives
    // the multi-instance UI (one row per account, each with its own label).
    async listInstances(): Promise<IntegrationInstance[]> {
      const response = await client.get({
        url: `/api/v1/integrations/${type}/instances`,
        throwOnError: false,
      });
      return (response.data as IntegrationInstance[]) ?? [];
    },

    // Pass `label` to disconnect a specific instance; omit it when there's
    // only one connected account.
    async disconnect(label?: string): Promise<TDisconnect> {
      const response = await client.delete({
        url: `/api/v1/integrations/${type}/disconnect`,
        ...(label ? { query: { label } } : {}),
      });
      return response.data as TDisconnect;
    },

    // Pass `label` to connect/reconnect a specific instance (a distinct label
    // adds another account of the same type); omit it for the first connection.
    // `returnMode='redirect'` asks the backend callback to 302 the top-level tab
    // back into the app instead of the popup postMessage handshake — used on
    // mobile, where the popup flow is unreliable (GET-8963).
    async getAuthUrl(
      label?: string,
      returnMode?: 'popup' | 'redirect',
    ): Promise<{ authorization_url: string }> {
      const query: Record<string, string> = {};
      if (label) query['label'] = label;
      if (returnMode) query['return_mode'] = returnMode;
      const response = await client.get({
        url: `/api/v1/integrations/${type}/auth`,
        ...(Object.keys(query).length ? { query } : {}),
      });
      return response.data as { authorization_url: string };
    },
  };
}

// Discovered-mode integrations (e.g. Zoho) where the user pastes their own
// resource URL and the backend discovers the OAuth server per-instance. Shares
// status/instances/disconnect with the static factory but swaps the no-input
// `getAuthUrl` for a `connect(resourceUrl, label?)` that POSTs the URL.
function createDiscoveredIntegrationService<
  TStatus = IntegrationStatusResponse,
  TDisconnect = IntegrationDisconnectResponse,
>(type: string) {
  const base = createIntegrationService<TStatus, TDisconnect>(type);
  return {
    getStatus: base.getStatus,
    listInstances: base.listInstances,
    disconnect: base.disconnect,

    // Kicks off the server-driven OAuth flow: the backend discovers the auth
    // server from `resourceUrl`, runs DCR + PKCE, and returns an
    // `authorization_url` for the frontend to open in a popup. Pass `label` to
    // add another account under a distinct name; omit it for the first
    // connection (which uses the default type label).
    async connect(
      resourceUrl: string,
      label?: string,
      returnMode?: 'popup' | 'redirect',
    ): Promise<{ authorization_url: string }> {
      // throwOnError: a swallowed 4xx comes back as an AxiosError-shaped
      // object where `data` is undefined and the body lives on
      // `response.data`. The caller destructures `data`, which explodes with
      // a confusing JS error and hides the backend's actual message (e.g. the
      // scope-budget guard). Throwing lets the modal's `err.response.data.detail`
      // path render the real error.
      // `returnMode='redirect'` asks the backend callback to 302 the top-level
      // tab back into the app instead of the popup handshake (mobile, GET-8975).
      const response = await client.post({
        url: `/api/v1/integrations/${type}/connect`,
        body: {
          resource_url: resourceUrl,
          ...(label ? { label } : {}),
          ...(returnMode ? { return_mode: returnMode } : {}),
        },
        throwOnError: true,
      });
      return response.data as { authorization_url: string };
    },
  };
}

// Pipedream-brokered integrations (e.g. Salesforce): auth + API access are
// brokered by Pipedream Connect. Shares status/instances/disconnect with the
// static factory but swaps `getAuthUrl` to POST the connect-token endpoint,
// which mints a hosted Connect Link URL. It returns the same
// `{ authorization_url }` shape as the OAuth path, so OAuthIntegrationPairingModal
// opens it in the popup and completes via the same `${name}-oauth` postMessage.
function createPipedreamIntegrationService<
  TStatus = IntegrationStatusResponse,
  TDisconnect = IntegrationDisconnectResponse,
>(type: string) {
  const base = createIntegrationService<TStatus, TDisconnect>(type);
  return {
    getStatus: base.getStatus,
    listInstances: base.listInstances,
    disconnect: base.disconnect,

    // `returnMode='redirect'` asks the backend callback to 302 the top-level tab
    // back into the app instead of the popup handshake (mobile, GET-8963).
    async getAuthUrl(
      label?: string,
      returnMode?: 'popup' | 'redirect',
    ): Promise<{ authorization_url: string }> {
      const query: Record<string, string> = {};
      if (label) query['label'] = label;
      if (returnMode) query['return_mode'] = returnMode;
      // throwOnError so a backend 4xx/5xx (e.g. "Pipedream not configured")
      // surfaces its `detail` to the modal instead of a confusing destructure.
      const response = await client.post({
        url: `/api/v1/integrations/${type}/pipedream/connect-token`,
        ...(Object.keys(query).length ? { query } : {}),
        throwOnError: true,
      });
      return response.data as { authorization_url: string };
    },
  };
}

/**
 * Attach the browser's IANA zone to a sign-in request as `tz`. The backend
 * seeds it as the account's home timezone when nothing better is known yet,
 * so the assistant's first answers are in the user's own wall-clock rather
 * than UTC (GET-13682). Read off the raw query string server-side, like the
 * tracking params, so it stays out of the OpenAPI schema. Best-effort: a
 * browser that cannot report a zone simply sends none.
 */
function setBrowserTimezoneParam(searchParams: URLSearchParams): void {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) searchParams.set('tz', tz);
  } catch {
    // Nothing actionable: the backend treats a missing zone as "no signal".
  }
}

export const authService = {
  // Start connecting a personal Gmail account (read + draft only). Returns the
  // Google OAuth URL to redirect the browser to; the backend persists the
  // account on callback and never touches the primary work account.
  // Live price of the personal-inbox add-on for the paywall modal. Throws on
  // 404 (billing unconfigured) — the modal then blocks connecting rather than
  // promising a price it can't bill.
  async getPersonalInboxAddonPricing(): Promise<{ price_formatted: string; interval: string }> {
    // throwOnError: swallowed, the 404 the backend returns when billing is
    // unconfigured would resolve as `undefined` — the paywall modal's catch
    // would never fire and it would show "…" forever instead of the
    // "couldn't load price" fallback.
    const response = await getAddonPricingApiV1AuthConnectEmailAddonPricingGet({
      throwOnError: true,
    });
    return response.data;
  },

  async getConnectPersonalEmailUrl(): Promise<string> {
    const response =
      await connectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGet({
        throwOnError: true,
      });
    return response.data.authorization_url;
  },

  // Same, for a personal Outlook/Microsoft account (Mail.Read + Mail.ReadWrite,
  // no Mail.Send — Graph withholds send at the scope level).
  async getConnectPersonalEmailUrlMicrosoft(): Promise<string> {
    const response =
      await connectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGet({
        throwOnError: true,
      });
    return response.data.authorization_url;
  },

  // The user's connected personal inboxes (for the settings card).
  async getConnectedEmailAccounts(): Promise<ConnectedAccountSummary[]> {
    const response = await listConnectedEmailAccountsApiV1AuthConnectEmailAccountsGet({
      throwOnError: true,
    });
    return response.data.accounts;
  },

  // Connect (or re-enter the password for) an IMAP personal inbox — iCloud,
  // Yahoo, Fastmail… The backend tests the sign-in before saving anything, so
  // a rejected password throws here with the server's own reason (GET-17286).
  async connectImapInbox(body: {
    email: string
    password: string
    host?: string | null
    // Set on a reconnect: the stored server is reused and only the password
    // is replaced.
    account_id?: number | null
    // The sign-in name for an iCloud/Fastmail custom-domain address.
    login?: string | null
    // The outgoing server for a host the form doesn't know (GET-17448).
    smtp_host?: string | null
  }): Promise<'success' | 'billing_error'> {
    const response = await connectImapInboxApiV1AuthConnectEmailImapPost({
      body,
      throwOnError: true,
    });
    return response.data.status;
  },

  // Disconnect a personal inbox (deletes its synced data too).
  async disconnectConnectedEmailAccount(accountId: number): Promise<void> {
    await disconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDelete({
      path: { account_id: accountId },
      throwOnError: true,
    });
  },

  async getLoginUrl(
    queryParams?: string | null,
    loginHint?: string | null,
  ): Promise<LoginResponse> {
    // Cookies are sent automatically via withCredentials: true
    // Pass all tracking params (utm_source, gclid, etc.) for attribution
    const searchParams = new URLSearchParams(queryParams ?? '');
    // Piggyback the current PostHog session/distinct IDs so the backend can
    // round-trip them through the Google OAuth `state` param — session
    // recordings get stitched across the redirect instead of restarting.
    const phSessionId = posthog.get_session_id?.();
    const phDistinctId = posthog.get_distinct_id?.();
    if (phSessionId) searchParams.set('ph_session_id', phSessionId);
    if (phDistinctId) searchParams.set('ph_distinct_id', phDistinctId);
    // Pre-select the account the user asked for (the work email they typed) in
    // Google's chooser, so a stray personal-Gmail session isn't silently reused
    // and the user can't get stuck in the personal-email loop (GET-8405).
    if (loginHint) searchParams.set('login_hint', loginHint);
    setBrowserTimezoneParam(searchParams);
    const query = searchParams.toString();
    const params = query ? `?${query}` : "";
    const response = await client.get({
      // throwOnError: a swallowed non-2xx returns `response.data === undefined`,
      // so a backend 500 surfaced only as a TypeError from the caller
      // destructuring `auth_url` off undefined — carrying neither the status
      // nor the backend's `detail`. With it the caller gets a real AxiosError,
      // so the login page can tell the user the sign-in never started instead
      // of appearing to do nothing (GET-12701).
      throwOnError: true,
      url: `/api/v1/auth/login${params}`,
    });
    return response.data as LoginResponse;
  },

  async getSSOLoginUrl(
    email: string,
    queryParams?: string | null,
  ): Promise<LoginResponse> {
    // Enterprise SSO. Unlike Google and Microsoft there is no single app to
    // redirect to, so the email is required rather than a hint: its domain is
    // what selects the organization whose Okta connection we use. The backend
    // re-resolves it and 404s if the domain has no active connection.
    //
    // Bypasses the generated SDK for the same reason its two siblings do: the
    // backend reads the tracking params (utm_source, gclid, ...) straight off
    // the raw query string, and they are deliberately absent from the OpenAPI
    // schema, so the typed client cannot carry them. Without this an SSO signup
    // keeps only the cookie-borne fbp/fbclid and loses utm/gclid attribution —
    // the endpoint's `_set_tracking_params_cookie` filters
    // `request.query_params`, so params that are never sent can't be captured.
    const searchParams = new URLSearchParams(queryParams ?? '');
    searchParams.set('email', email);
    setBrowserTimezoneParam(searchParams);
    const response = await client.get({
      // throwOnError: as on getLoginUrl above — swallowed, a non-2xx reaches
      // the caller as `undefined` data, not an error carrying the status.
      throwOnError: true,
      url: `/api/v1/auth/okta/login?${searchParams.toString()}`,
    });
    return response.data as LoginResponse;
  },

  async getMicrosoftLoginUrl(
    queryParams?: string | null,
    loginHint?: string | null,
  ): Promise<LoginResponse> {
    // Microsoft OAuth login - uses same response type as Google
    // Pass all tracking params (utm_source, gclid, etc.) for attribution
    const searchParams = new URLSearchParams(queryParams ?? '');
    // Pre-select the account the user asked for (the work email they typed) in
    // Microsoft's chooser. Mirrors the Google passthrough above; the backend
    // reads it off the raw query string, so it stays out of the generated SDKs.
    if (loginHint) searchParams.set('login_hint', loginHint);
    setBrowserTimezoneParam(searchParams);
    const query = searchParams.toString();
    const params = query ? `?${query}` : "";
    const response = await client.get({
      // throwOnError: as on getLoginUrl above — swallowed, a non-2xx reaches
      // the caller as `undefined` data, not an error carrying the status.
      throwOnError: true,
      url: `/api/v1/auth/microsoft/login${params}`,
    });
    return response.data as LoginResponse;
  },

  async detectEmailProvider(email: string): Promise<DetectEmailProviderResponse> {
    const response = await detectEmailProviderEndpointApiV1AuthDetectEmailProviderPost({
      body: { email },
      throwOnError: true,
    });
    return response.data;
  },

  // Sends support the address someone left after their sign-in failed. Throws
  // on any non-2xx so the form can point them at support directly instead.
  // `companyWebsite` is the form's spam-trap field, passed through as filled.
  async requestSignInHelp(
    email: string,
    provider: AuthProvider,
    reason: string | null,
    companyWebsite: string | null,
  ): Promise<void> {
    await requestSignInHelpApiV1PublicSignInHelpPost({
      body: { email, provider, reason, company_website: companyWebsite },
      throwOnError: true,
    });
  },

  async getCurrentUser(): Promise<UserResponse> {
    // Cookies are sent automatically via withCredentials: true
    const response = await getCurrentUserApiV1AuthMeGet({ throwOnError: true });
    return response.data;
  },

  async getAssistantCharacter(): Promise<AssistantCharacterResponse> {
    // Cookies are sent automatically via withCredentials: true
    const response = await getUserAssistantCharacterApiV1AuthMeAssistantGet({
      throwOnError: true,
    });
    return response.data;
  },

  // throwOnError on these character mutations: a swallowed failure returns
  // `undefined`, so callers fake success and then crash on the missing object
  // (the onboarding custom-character incident). Throw so the caller's catch can
  // surface the real error and keep its state intact.
  async listAssistantCharacters(): Promise<AssistantCharacterResponse[]> {
    const response = await listAssistantCharactersApiV1AuthCharactersGet({
      throwOnError: true,
    });
    return response.data;
  },

  async updateAssistantCharacter(
    characterId: number,
  ): Promise<AssistantCharacterResponse> {
    // Cookies are sent automatically via withCredentials: true
    const response = await updateUserAssistantCharacterApiV1AuthMeAssistantPut({
      query: { character_id: characterId },
      throwOnError: true,
    });
    return response.data;
  },

  /**
   * Rename the user's assistant everywhere, or reset it to the character's own
   * name with `null` (GET-14050). Personality, picture and voice are untouched.
   */
  async updateAssistantName(
    name: string | null,
  ): Promise<AssistantCharacterResponse> {
    const response = await updateUserAssistantNameApiV1AuthMeAssistantNamePut({
      body: { name },
      throwOnError: true,
    });
    return response.data;
  },

  async createCustomCharacter(
    data: CustomCharacterDetails,
  ): Promise<AssistantCharacterResponse> {
    const response = await createCustomCharacterApiV1AuthCharactersCustomPost({
      body: data,
      throwOnError: true,
    });
    return response.data;
  },

  async deleteCustomCharacter(): Promise<void> {
    await deleteCustomCharacterApiV1AuthCharactersCustomDelete({
      throwOnError: true,
    });
  },

  /**
   * Replace the custom character's generated headshot with an uploaded photo.
   * Gated by the `custom-profile-picture-upload` flag, which fails closed: the
   * endpoint 404s when it is off.
   */
  async uploadCustomCharacterPicture(
    file: File,
  ): Promise<AssistantCharacterResponse> {
    const response =
      await uploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePost({
        body: { file },
        throwOnError: true,
      });
    return response.data;
  },

  /**
   * Drop the uploaded photo and regenerate a headshot. The returned character
   * has no picture yet — poll until the generated one lands.
   */
  async revertCustomCharacterPicture(): Promise<AssistantCharacterResponse> {
    const response =
      await revertCustomCharacterPictureApiV1AuthCharactersCustomPictureDelete({
        throwOnError: true,
      });
    return response.data;
  },

  async listCharacterVoices(): Promise<VoiceOption[]> {
    const response = await listCharacterVoicesApiV1AuthCharactersVoicesGet({
      throwOnError: true,
    });
    return response.data;
  },

  async updateCustomCharacterVoice(
    voice: string,
  ): Promise<AssistantCharacterResponse> {
    const response = await updateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePut({
      body: { voice },
      throwOnError: true,
    });
    return response.data;
  },

  async completeSetup(): Promise<UserResponse> {
    // throwOnError: the caller stores the result as the auth user, and a
    // swallowed 4xx/5xx would hand it `undefined` — signing the app out
    // instead of surfacing the failure.
    const response = await completeSetupApiV1AuthMeCompleteSetupPost({
      throwOnError: true,
    });
    return response.data;
  },

  async logout(): Promise<void> {
    // Call backend to clear the httponly cookie
    await client.post({ url: "/api/v1/auth/logout", throwOnError: true });
  },

  // Ends every session this user has, on every device — the remedy for a
  // stolen laptop or a shared machine. The plain logout above clears this
  // browser only.
  async logoutEverywhere(): Promise<void> {
    await signOutEverywhereApiV1AuthLogoutEverywherePost({ throwOnError: true });
  },
};

export const scopeService = {
  async getStatus(): Promise<ScopeStatusResponse> {
    // throwOnError: without it a failed request (network error or any non-2xx)
    // resolves to `undefined` instead of rejecting, so every caller's
    // `.catch(() => null)` is skipped. The onboarding wizard then passed that
    // `undefined` to hasScopeCluster mid-render and went blank (GET-20007).
    const response = await scopeStatusApiV1AuthScopeStatusGet({
      throwOnError: true,
    });
    return response.data;
  },

  async requestScopes(
    clusters: string[],
    returnPath: string,
    // Defaults to TRUE. Every one of the five call sites passes true, and the
    // paragraph below is why: false lets Google silently re-issue a partial
    // grant, stranding the user. A `false` default meant the one shape nobody
    // wants was the one you got by forgetting the argument.
    forceConsent = true,
  ): Promise<void> {
    // forceConsent appends ``prompt=consent`` so Google re-shows the granular
    // permission screen. Without it, ``include_granted_scopes=true`` (set on the
    // backend) makes Google silently re-issue a previously partial grant — so a
    // user who left a box unchecked can never complete the connection.
    // throwOnError: otherwise a failed request returns `undefined`, and the
    // `response.data!.auth_url` access below throws a cryptic TypeError instead
    // of letting the caller show why Google sign-in couldn't be started.
    const response = await requestScopesApiV1AuthRequestScopesGet({
      query: {
        scopes: clusters.join(","),
        return_path: returnPath,
        force_consent: forceConsent,
      },
      throwOnError: true,
    });
    const authUrl = response.data?.auth_url;
    // A 200 whose body lacks auth_url would coerce to the string "undefined"
    // and navigate to /integrations/undefined without ever rejecting, so the
    // caller's error slot never fills (GET-12886).
    if (!authUrl) throw new Error("Scope request returned no auth_url");
    window.location.href = authUrl;
  },
};

export const whatsappService = {
  async getStatus(): Promise<WhatsAppStatusResponse> {
    const response = await getWhatsappStatusApiV1WhatsappStatusGet({
      throwOnError: true,
    });
    return response.data;
  },

  async generateVerificationCode(): Promise<VerificationCodeResponse> {
    const response =
      await generateVerificationCodeApiV1WhatsappGenerateCodePost({
        throwOnError: true,
      });
    return response.data;
  },

  async disconnect(): Promise<WhatsAppDisconnectResponse> {
    const response = await disconnectWhatsappApiV1WhatsappDisconnectDelete({
      throwOnError: true,
    });
    return response.data;
  },
};

export const smsService = {
  async getStatus(): Promise<SmsStatusResponse> {
    const response = await getSmsStatusApiV1SmsStatusGet({ throwOnError: true });
    return response.data;
  },

  async generateVerificationCode(phoneNumber: string): Promise<SmsGenerateCodeResponse> {
    const response = await generateVerificationCodeApiV1SmsGenerateCodePost({
      body: { phone_number: phoneNumber },
      throwOnError: true,
    });
    return response.data;
  },

  async verifyCode(phoneNumber: string, verificationCode: string): Promise<SmsVerifyCodeResponse> {
    const response = await verifySmsCodeApiV1SmsVerifyCodePost({
      body: {
        phone_number: phoneNumber,
        verification_code: verificationCode,
      },
      throwOnError: true,
    });
    return response.data;
  },

  async disconnect(): Promise<SmsDisconnectResponse> {
    const response = await disconnectSmsApiV1SmsDisconnectDelete({ throwOnError: true });
    return response.data;
  },
};

export const imessageService = {
  async getStatus(): Promise<IMessageStatusResponse> {
    const response = await getImessageStatusApiV1ImessageStatusGet({ throwOnError: true });
    return response.data;
  },

  /** A deep link that pre-fills the pairing code. */
  async generateVerificationCode(): Promise<IMessageGenerateCodeResponse> {
    const response = await generateVerificationCodeApiV1ImessageGenerateCodePost({
      body: {},
      throwOnError: true,
    });
    return response.data;
  },

  async disconnect(identifier?: string): Promise<IMessageDisconnectResponse> {
    const response = await disconnectImessageApiV1ImessageDisconnectDelete({
      ...(identifier ? { query: { identifier } } : {}),
      throwOnError: true,
    });
    return response.data;
  },
};

export const slackService = {
  async getStatus(): Promise<SlackStatusResponse> {
    const response = await getSlackStatusApiV1SlackStatusGet({
      throwOnError: true,
    });
    return response.data;
  },

  async initiateOAuth(): Promise<SlackOAuthInitResponse> {
    const response = await initiateSlackOauthApiV1SlackOauthInitiatePost({
      throwOnError: true,
    });
    return response.data;
  },

  async handleCallback(
    callbackData: SlackOAuthCallbackData,
  ): Promise<SlackStatusResponse> {
    const response = await handleSlackOauthCallbackApiV1SlackOauthCallbackPost({
      body: callbackData,
      throwOnError: true,
    });
    return response.data;
  },

  async disconnect(): Promise<SlackDisconnectResponse> {
    const response = await disconnectSlackApiV1SlackDisconnectDelete({
      throwOnError: true,
    });
    return response.data;
  },
};

// The owner's own read-only Slack connection (GET-14181) — separate from
// the workspace (bot) install above; a user may hold either or both.
export const slackPersonalService = {
  async getStatus(): Promise<SlackPersonalStatusResponse> {
    const response = await getSlackPersonalStatusApiV1SlackPersonalStatusGet({ throwOnError: true });
    return response.data;
  },

  async initiateOAuth(): Promise<SlackOAuthInitResponse> {
    const response = await initiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePost({
      throwOnError: true,
    });
    return response.data;
  },

  async handleCallback(
    callbackData: SlackOAuthCallbackData,
  ): Promise<SlackPersonalStatusResponse> {
    const response = await handleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPost({
      body: callbackData,
      throwOnError: true,
    });
    return response.data;
  },

  async listConversations(): Promise<SlackPersonalConversationsResponse> {
    const response = await listSlackPersonalConversationsApiV1SlackPersonalConversationsGet({
      throwOnError: true,
    });
    return response.data;
  },

  async updateAccess(body: SlackPersonalAccessUpdate): Promise<SlackPersonalStatusResponse> {
    const response = await updateSlackPersonalAccessApiV1SlackPersonalAccessPut({
      body,
      throwOnError: true,
    });
    return response.data;
  },

  async disconnect(): Promise<void> {
    await disconnectSlackPersonalApiV1SlackPersonalDisconnectDelete({ throwOnError: true });
  },
};

// Which Teams conversations the assistant may read through the user's
// Pipedream Microsoft Teams connection (GET-14326) — the Teams twin of the
// Slack personal list. The connection itself is the Pipedream one; this is
// only the permission on it.
export const teamsAccessService = {
  async getStatus(): Promise<TeamsAccessStatusResponse> {
    const response = await getTeamsAccessStatusApiV1TeamsAccessStatusGet({ throwOnError: true });
    return response.data;
  },

  async listConversations(): Promise<TeamsAccessConversationsResponse> {
    const response = await listTeamsAccessConversationsApiV1TeamsAccessConversationsGet({
      throwOnError: true,
    });
    return response.data;
  },

  async updateAccess(body: TeamsAccessUpdate): Promise<TeamsAccessStatusResponse> {
    const response = await updateTeamsAccessApiV1TeamsAccessPut({ body, throwOnError: true });
    return response.data;
  },
};

// Pages the assistant built for the signed-in user (GET-15593). Only the
// owner's session can read one; any other view id is a 404.
export const assistantViewService = {
  async list(search?: string): Promise<AssistantViewIndex> {
    const response = await listMyViewsApiV1ViewsGet({
      ...(search ? { query: { q: search } } : {}),
      throwOnError: true,
    });
    return response.data;
  },

  /** `force` runs snippets now even while they rest after their last run: the owner pressed Refresh. */
  async get(viewId: string, fresh: boolean, force = false): Promise<AssistantViewPage> {
    const response = await getMyViewApiV1ViewsViewIdGet({
      path: { view_id: viewId },
      query: force ? { fresh, force } : { fresh },
      throwOnError: true,
    });
    return response.data;
  },
};

// Zoom service (manual implementation until SDK regeneration)
export const zoomService = {
  async getStatus(): Promise<ZoomStatusResponse> {
    const response = await client.get({
      url: "/api/v1/auth/zoom/status",
    });
    return response.data as ZoomStatusResponse;
  },

  async initiateOAuth(): Promise<ZoomOAuthInitResponse> {
    const response = await client.post({
      url: "/api/v1/auth/zoom/oauth/initiate",
    });
    return response.data as ZoomOAuthInitResponse;
  },

  async handleCallback(
    callbackData: ZoomOAuthCallbackData,
  ): Promise<ZoomStatusResponse> {
    try {
      const response = await client.post({
        url: "/api/v1/auth/zoom/oauth/callback",
        body: callbackData,
      });
      return response.data as ZoomStatusResponse;
    } catch (error: any) {
      if (error.response) {
        const errorData = error.response.data || {};
        throw {
          response: {
            status: error.response.status,
            data: errorData,
          },
        };
      }
      throw error;
    }
  },

  async disconnect(): Promise<ZoomDisconnectResponse> {
    const response = await client.delete({
      url: "/api/v1/auth/zoom/disconnect",
    });
    return response.data as ZoomDisconnectResponse;
  },
};

export const granolaService = createIntegrationService<GranolaStatusResponse, GranolaDisconnectResponse>('granola');
export const clickupService = createIntegrationService<ClickUpStatusResponse, ClickUpDisconnectResponse>('clickup');
export const asanaService = createIntegrationService<AsanaStatusResponse, AsanaDisconnectResponse>('asana');
export const notionService = createIntegrationService<NotionStatusResponse, NotionDisconnectResponse>('notion');
export const hubspotService = createIntegrationService<HubSpotStatusResponse, HubSpotDisconnectResponse>('hubspot');
// HubSpot is migrating to Pipedream Connect (dual-path). This variant POSTs the
// pipedream/connect-token endpoint for getAuthUrl; HubSpotPairingModal uses it
// for every NEW connection. Status/instances/disconnect are shared with
// `hubspotService` (same endpoints), so existing native connections keep using
// `hubspotService` unchanged.
export const hubspotPipedreamService = createPipedreamIntegrationService<HubSpotStatusResponse, HubSpotDisconnectResponse>('hubspot');
export const attioService = createIntegrationService<AttioStatusResponse, AttioDisconnectResponse>('attio');
// Salesforce connects via Pipedream Connect (managed auth + API proxy), not a
// self-hosted OAuth app — its getAuthUrl POSTs the connect-token endpoint.
export const salesforceService = createPipedreamIntegrationService<SalesforceStatusResponse, SalesforceDisconnectResponse>('salesforce');
// HoneyBook runs its own OAuth server (Ory) with Dynamic Client Registration,
// so it uses the self-hosted flow rather than Pipedream Connect.
export const honeybookService = createIntegrationService<HoneyBookStatusResponse, HoneyBookDisconnectResponse>('honeybook');
export const fathomService = createIntegrationService<FathomStatusResponse, FathomDisconnectResponse>('fathom');
export const otterService = createIntegrationService<OtterStatusResponse, OtterDisconnectResponse>('otter');
export const wisprService = createIntegrationService<WisprStatusResponse, WisprDisconnectResponse>('wispr');

// Zoho MCP is OAuth-protected: each user runs their own MCP server at
// mcp.zoho.com (with its own authorization server, discoverable via
// `.well-known/oauth-authorization-server` at the MCP origin). It rides the
// generic discovered-auth connect mode — `connect()` posts the pasted MCP URL
// and the backend handles discovery + DCR + PKCE + code exchange + token
// persistence.
export const zohoService = createDiscoveredIntegrationService('zoho');

// Promoted (monty-backed) integrations — registered at build time, available
// to every user after merge of the promotion PR. The frontend rendering is
// fully data-driven from the backend list.

export type {
 PromotedIntegrationSummary
}

export const featuredIntegrationsService = {
  /**
   * The Pipedream apps the integrations page renders as first-party tiles.
   *
   * A static catalogue — it deliberately carries no per-user connection state,
   * because the page already holds the live connection list and a second
   * answer to "is this connected" would go stale the moment somebody connects
   * one.
   */
  async list(): Promise<FeaturedIntegrationSummary[]> {
    const response = await listFeaturedIntegrationsApiV1IntegrationsFeaturedGet({
      throwOnError: true,
    })
    return response.data ?? []
  },
}

export const promotedIntegrationsService = {
  async list(): Promise<PromotedIntegrationSummary[]> {
    const response = await listPromotedIntegrationsApiV1IntegrationsPromotedGet({ throwOnError: false })
    return response.data ?? []
  },

  async ensureSpec(name: string): Promise<PromotedIntegrationEnsureSpecResponse> {
    // throwOnError: otherwise the SDK swallows 4xx (e.g. the 409 raised when the
    // user already has a same-named custom integration that differs from the
    // promoted template) and returns ``data: undefined``, so the caller's
    // ``{ spec_id }`` destructure explodes with a confusing JS error instead of
    // surfacing the backend's actionable message. The error propagates
    // unchanged: callers read the message through getUserFacingApiErrorMessage,
    // which needs the status to tell that 409 from a 5xx (GET-20009).
    const response = await ensurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPost({
      path: { name },
      throwOnError: true,
    })
    return response.data
  },

  async disconnect(name: string): Promise<void> {
    await disconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDelete(
      { path: { name }, throwOnError: true },
    )
  },
}

export const pipedreamAppsService = {
  async listApps(
    query?: string,
    after?: string,
    limit = 48,
  ): Promise<PipedreamAppCatalogPageResponse> {
    const response = await listPipedreamAppsApiV1IntegrationsPipedreamAppsGet({
      query: {
        ...(query ? { q: query } : {}),
        ...(after ? { after } : {}),
        limit,
      },
      throwOnError: true,
    })
    return response.data
  },

  async listConnections(): Promise<PipedreamAppConnectionResponse[]> {
    const response =
      await listPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGet({
        throwOnError: true,
      })
    return response.data
  },

  // `label` names the account: a new one is added beside the app's other
  // accounts, an existing one is reconnected. Omitted, it is the first account.
  async getAuthUrl(
    appSlug: string,
    returnMode?: 'popup' | 'redirect',
    label?: string,
  ): Promise<{ authorization_url: string }> {
    const response =
      await createGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPost({
        path: { app_slug: appSlug },
        query: {
          ...(returnMode ? { return_mode: returnMode } : {}),
          ...(label ? { label } : {}),
        },
        throwOnError: true,
      })
    return response.data
  },

  async disconnect(connectionId: number): Promise<void> {
    await disconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDelete({
      path: { connection_id: connectionId },
      throwOnError: true,
    })
  },
}

export const integrationRequestService = {
  async submit(data: { integration_name: string; use_cases: string; category: string }): Promise<IntegrationRequestResponse> {
    const response = await requestIntegrationApiV1IntegrationsRequestPost({
      body: data,
      throwOnError: true,
    })
    return response.data
  },
};

// A suggestion as the connect flow takes it. `account_label` is set only when
// adding another account of a Pipedream app the user already has, and names it.
export type ConnectableSuggestion = IntegrationSuggestionItem & {
  account_label?: string | undefined
}

// The deterministic inbox scan's shortlist. One endpoint serves both readers —
// the onboarding tools step asks for 16, the integrations page row for 6 — so
// the limit is the only thing that differs between them.
export const integrationSuggestionsService = {
  // `excludeBuiltIn` omits the apps we have built an integration for. The
  // integrations page gives each of those its own tile in a category card, so
  // repeating them under "More tools you might need" proposes what the user is
  // already looking at. Onboarding has no such tiles and leaves it off.
  async list(
    limit: number,
    { excludeBuiltIn = false }: { excludeBuiltIn?: boolean } = {},
  ): Promise<IntegrationSuggestionsResponse> {
    const response = await getIntegrationSuggestionsApiV1IntegrationSuggestionsGet({
      query: { limit, ...(excludeBuiltIn ? { exclude_built_in: true } : {}) },
      throwOnError: true,
    })
    return response.data
  },

  async dismiss(catalogKey: string): Promise<void> {
    await dismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPost({
      path: { catalog_key: catalogKey },
      throwOnError: true,
    })
  },

  // Resolves the URL that starts a connection for one suggestion.
  //
  // Every branch returns a plain URL the caller opens in a popup, which is what
  // lets both suggestion surfaces share one connect flow instead of each
  // re-deriving our tier table — the thing that previously sent in-house apps
  // through the Pipedream catalog and wrote the wrong kind of connection.
  // `connect_method` comes from the server precisely so this switch is the only
  // place the mapping lives.
  //
  // `manual` is absent on purpose: a discovered-OAuth app needs the user to
  // paste their own resource URL first, so there is no URL to return and
  // callers must route to the integrations page instead. Throwing here would
  // turn a known-unsupported case into a runtime error, so it is the caller's
  // job to filter — see `isInlineConnectable`.
  async connectUrl(
    suggestion: ConnectableSuggestion,
    returnMode: 'popup' | 'redirect' = 'popup',
  ): Promise<string> {
    const name = suggestion.integration_name
    switch (suggestion.connect_method) {
      case 'pipedream_app': {
        const { authorization_url } = await pipedreamAppsService.getAuthUrl(
          name,
          returnMode,
          suggestion.account_label,
        )
        return authorization_url
      }
      case 'integration_oauth': {
        const { authorization_url } = await createIntegrationService(
          name,
        ).getAuthUrl(undefined, returnMode)
        return authorization_url
      }
      case 'integration_pipedream': {
        const { authorization_url } = await createPipedreamIntegrationService(
          name,
        ).getAuthUrl(undefined, returnMode)
        return authorization_url
      }
      // A promoted app materializes a per-user clone of the template spec, then
      // sends the user to whichever credential flow its auth kind needs. The
      // server tells us which of the two, so this costs one round-trip rather
      // than fetching the whole promoted listing to re-read one enum.
      case 'promoted_oauth': {
        const { spec_id } = await promotedIntegrationsService.ensureSpec(name)
        return customIntegrationsService.oauthUrl(spec_id)
      }
      case 'promoted_secret': {
        const { spec_id } = await promotedIntegrationsService.ensureSpec(name)
        return await customIntegrationsService.createSecretRequest(spec_id)
      }
      default:
        throw new Error(`No inline connect flow for ${name}`)
    }
  },
};

/**
 * Can this suggestion be connected without leaving the page?
 *
 * False only for `manual` (discovered-OAuth, Zoho today), where the connection
 * genuinely cannot start until the user supplies a region-specific resource
 * URL. Kept as a named predicate so the two surfaces answer it identically —
 * onboarding renders those tiles inert rather than shipping a button that
 * cannot work, and the integrations page opens its existing modal.
 */
export function isInlineConnectable(
  suggestion: IntegrationSuggestionItem,
): boolean {
  return suggestion.connect_method !== 'manual'
}

export const webhookService = {
  async list(): Promise<WebhookIntegrationResponse[]> {
    const response = await client.get({
      url: "/api/v1/webhooks/integrations",
    });
    return response.data as WebhookIntegrationResponse[];
  },

  async create(data: WebhookIntegrationCreate): Promise<WebhookIntegrationWithTokenResponse> {
    const response = await client.post({
      url: "/api/v1/webhooks/integrations",
      body: data,
    });
    return response.data as WebhookIntegrationWithTokenResponse;
  },

  async update(
    integrationId: string,
    data: WebhookIntegrationUpdate,
  ): Promise<WebhookIntegrationResponse> {
    const response = await client.patch({
      url: `/api/v1/webhooks/integrations/${integrationId}`,
      body: data,
    });
    return response.data as WebhookIntegrationResponse;
  },

  async delete(integrationId: string): Promise<void> {
    await client.delete({
      url: `/api/v1/webhooks/integrations/${integrationId}`,
    });
  },

  async regenerateToken(integrationId: string): Promise<WebhookIntegrationWithTokenResponse> {
    const response = await client.post({
      url: `/api/v1/webhooks/integrations/${integrationId}/regenerate-token`,
    });
    return response.data as WebhookIntegrationWithTokenResponse;
  },
};

export const customIntegrationsService = {
  async list(): Promise<CustomIntegrationSummary[]> {
    const response = await listCustomIntegrationsEndpointApiV1IntegrationsCustomGet({ throwOnError: false })
    return response.data ?? []
  },

  async delete(specId: number): Promise<void> {
    await deleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDelete({
      path: { spec_id: specId },
      throwOnError: true,
    })
  },

  async createSecretRequest(specId: number): Promise<string> {
    const response = await createCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPost({
      path: { spec_id: specId },
      throwOnError: true,
    })
    return response.data.url
  },

  oauthUrl(specId: number): string {
    return `${API_BASE_URL}/api/v1/integrations/custom/${specId}/auth`
  },
}

export type {
  SharedIntegrationSummary,
}

// Integrations an admin shared with the current user. Each entry is a snapshot
// clone with its own spec_id, so the recipient connects their own credentials
// through the same /custom/{spec_id} flow as customIntegrationsService.
export const sharedIntegrationsService = {
  async list(): Promise<SharedIntegrationSummary[]> {
    const response = await listSharedIntegrationsApiV1IntegrationsSharedGet({ throwOnError: false })
    return response.data ?? []
  },
}

export const billingService = {
  async getPricing(): Promise<PricingResponse> {
    const response = await getPricingApiV1BillingPricingGet({ throwOnError: true });
    return response.data;
  },

  async getSubscription(): Promise<SubscriptionResponse> {
    const response = await getSubscriptionStatusApiV1BillingSubscriptionGet({
      throwOnError: true,
    });
    return response.data;
  },

  async createCheckoutSession(
    returnUrl: string,
    // Named rather than positional: these are two adjacent booleans, so as
    // positional args a transposed call would type-check cleanly and silently
    // send the wrong request — start billing immediately instead of restating
    // the trial terms, or the reverse.
    options: { convert?: boolean, restateTrialTerms?: boolean } = {},
  ): Promise<CheckoutResponse> {
    // The stored referral code is read HERE rather than passed by the caller,
    // so a checkout entry point cannot forget it. It used to be an optional
    // argument, and both the onboarding step and Settings omitted it — which
    // type-checks, lints, and silently costs the referred user the first-month
    // discount the invite email promises, the attribution row that pays the
    // referrer, and the funnel event (GET-11900). There is deliberately no
    // opt-out parameter: one way for the code to reach Stripe is the point, and
    // suppressing it is already the backend's job — routers/billing.py resolves
    // a code only for users with no payment history, and drops invalid or
    // self-referral codes silently.
    const referralCode = getValidStoredReferralCode()
    // throwOnError: a swallowed failure returns `undefined`, and destructuring
    // `client_secret` off it crashes the caller instead of showing the error.
    // `convert`: start billing immediately (end the trial) instead of restarting one.
    // `restateTrialTerms`: have Stripe repeat the trial terms above its pay
    // button. Passed by callers whose screen led with the free period, so the
    // "no charge today" promise survives into the Stripe iframe, which our own
    // copy cannot reach. Defaults off, so every other entry point is unchanged.
    const response = await checkoutApiV1BillingCheckoutPost({
      body: {
        return_url: returnUrl,
        referral_code: referralCode ?? null,
        convert: options.convert ?? false,
        restate_trial_terms: options.restateTrialTerms ?? false,
      },
      throwOnError: true,
    });
    return response.data;
  },

  // Prepaid purchase credits (the wallet `web_task` purchases are paid from).
  // Both endpoints re-check the `purchase-credits-topup` flag server-side, so
  // an account the flag hasn't reached gets a 403 rather than a Stripe session
  // — the client's own flag read only decides whether the card renders.
  async getPurchaseCredits(): Promise<PurchaseCreditsResponse> {
    const response = await getPurchaseCreditsApiV1BillingPurchaseCreditsGet({
      throwOnError: true,
    });
    return response.data;
  },

  async createPurchaseCreditsCheckout(
    returnUrl: string,
    amountCents: number,
  ): Promise<CheckoutResponse> {
    const response = await purchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPost({
      body: { return_url: returnUrl, amount_cents: amountCents },
      throwOnError: true,
    });
    return response.data;
  },

  async createPortalSession(returnUrl: string): Promise<PortalResponse> {
    const response = await portalApiV1BillingPortalPost({
      body: { return_url: returnUrl },
      throwOnError: true,
    });
    return response.data;
  },

  async createPortalSessionFromLink(token: string): Promise<PortalResponse> {
    const response = await portalFromSignedLinkApiV1BillingPortalLinkPost({
      body: { token },
      throwOnError: true,
    });
    return response.data;
  },

  // Apply a promotion code to the user's existing subscription. Rejections
  // (unknown code, already discounted, Stripe refusing the code) arrive as
  // 4xx with a `detail` meant to be shown as-is — see getApiErrorMessage.
  async applyPromotionCode(code: string): Promise<ApplyPromotionCodeResponse> {
    const response = await applyPromotionCodeApiV1BillingPromotionCodePost({
      body: { code },
      throwOnError: true,
    });
    return response.data;
  },
};

export const organizationService = {
  async getAccess(): Promise<OrganizationAccessResponse> {
    const response = await getOrganizationAccessApiV1OrganizationAccessGet({
      throwOnError: true,
    });
    return response.data;
  },

  /** The caller's org, or null when they haven't joined/created one (404). */
  async getMyOrganization(): Promise<OrganizationResponse | null> {
    try {
      const response = await getMyOrganizationApiV1OrganizationGet({
        throwOnError: true,
      });
      return response.data;
    } catch (err) {
      if (getApiErrorStatus(err) === 404) return null;
      throw err;
    }
  },

  async createOrganization(name: string): Promise<OrganizationResponse> {
    const response = await createOrganizationEndpointApiV1OrganizationPost({
      body: { name },
      throwOnError: true,
    });
    return response.data;
  },

  async getMembers(): Promise<OrganizationMemberResponse[]> {
    const response = await getMembersApiV1OrganizationMembersGet({
      throwOnError: true,
    });
    return response.data;
  },

  async getStats(): Promise<OrganizationStatsResponse> {
    const response = await getOrganizationStatsApiV1OrganizationStatsGet({
      throwOnError: true,
    });
    return response.data;
  },

  async getPendingInvites(): Promise<PendingInviteResponse[]> {
    const response = await getPendingInvitesApiV1OrganizationInvitesGet({
      throwOnError: true,
    });
    return response.data;
  },

  async createInvites(emails: string[]): Promise<InviteBatchResponse> {
    const response = await createInvitesApiV1OrganizationInvitesPost({
      body: { emails },
      throwOnError: true,
    });
    return response.data;
  },

  async revokeInvite(inviteId: number): Promise<void> {
    await revokeInviteEndpointApiV1OrganizationInvitesInviteIdDelete({
      path: { invite_id: inviteId },
      throwOnError: true,
    });
  },

  /** The team's skills and pending changes, read-only; `enabled` false when off. */
  async getTeamSkills(): Promise<TeamSkillsPageResponse> {
    const response = await getTeamSkillsApiV1OrganizationTeamSkillsGet({
      throwOnError: true,
    });
    return response.data;
  },

  /**
   * Domains and addresses whose mail and meetings are private for the whole
   * team, oldest first, each with who added it and when.
   */
  async getRedactedEntries(): Promise<RedactedEntryResponse[]> {
    const response = await getRedactedEntriesApiV1OrganizationRedactedEntriesGet({
      throwOnError: true,
    });
    return response.data.entries;
  },

  /**
   * Adds to the list and returns all of it, normalized — which is what should
   * be rendered. Values already there keep their original record. The server
   * refuses the whole request if any value is neither a domain nor an address.
   */
  async addRedactedEntries(values: string[]): Promise<RedactedEntryResponse[]> {
    const response = await addRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPost({
      body: { values },
      throwOnError: true,
    });
    return response.data.entries;
  },

  /** Removes one entry and returns what remains. */
  async removeRedactedEntry(entryId: number): Promise<RedactedEntryResponse[]> {
    const response = await removeRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDelete({
      path: { entry_id: entryId },
      throwOnError: true,
    });
    return response.data.entries;
  },

  /** Pending team invites addressed to the caller (the consent flow). */
  async getMyInvites(): Promise<MyInviteResponse[]> {
    const response = await getMyInvitesApiV1OrganizationInvitesMineGet({
      throwOnError: true,
    });
    return response.data;
  },

  async acceptInvite(inviteId: number): Promise<void> {
    await acceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPost({
      path: { invite_id: inviteId },
      throwOnError: true,
    });
  },

  async declineInvite(inviteId: number): Promise<void> {
    await declineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePost({
      path: { invite_id: inviteId },
      throwOnError: true,
    });
  },

  /** "We're not a company" — stop auto-joining this email directory entirely. */
  async declineAutoJoin(): Promise<void> {
    await declineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePost({
      throwOnError: true,
    });
  },

  async leaveOrganization(): Promise<void> {
    await leaveOrganizationEndpointApiV1OrganizationLeavePost({
      throwOnError: true,
    });
  },

  async getEligibleUsers(): Promise<EligibleUserResponse[]> {
    const response = await getEligibleUsersApiV1OrganizationEligibleUsersGet({
      throwOnError: true,
    });
    return response.data;
  },

  async migrateMembers(userIds: number[]): Promise<MigrateBatchResponse> {
    const response = await migrateMembersApiV1OrganizationMembersMigratePost({
      body: { user_ids: userIds },
      throwOnError: true,
    });
    return response.data;
  },

  async deactivateMember(userId: number): Promise<void> {
    await deactivateMemberApiV1OrganizationMembersUserIdDeactivatePost({
      path: { user_id: userId },
      throwOnError: true,
    });
  },

  async reactivateMember(userId: number): Promise<void> {
    await reactivateMemberApiV1OrganizationMembersUserIdReactivatePost({
      path: { user_id: userId },
      throwOnError: true,
    });
  },

  async promoteMember(userId: number): Promise<void> {
    await promoteMemberEndpointApiV1OrganizationMembersUserIdPromotePost({
      path: { user_id: userId },
      throwOnError: true,
    });
  },

  async removeMember(userId: number): Promise<void> {
    await removeMemberEndpointApiV1OrganizationMembersUserIdDelete({
      path: { user_id: userId },
      throwOnError: true,
    });
  },

  // Either a Stripe client secret to open Checkout with, or — when the admin's
  // own subscription became the team plan — nothing to check out and billing
  // already live. Branch on `adopted_personal_subscription` rather than on a
  // null secret, so a future third outcome isn't silently read as adoption.
  async createBillingCheckout(returnUrl: string): Promise<OrgCheckoutResponse> {
    const response = await orgBillingCheckoutApiV1OrganizationBillingCheckoutPost({
      body: { return_url: returnUrl },
      throwOnError: true,
    });
    return response.data;
  },

  async createBillingPortal(returnUrl: string): Promise<string> {
    const response = await orgBillingPortalApiV1OrganizationBillingPortalPost({
      body: { return_url: returnUrl },
      throwOnError: true,
    });
    return response.data.url;
  },
};

// Which provider hosts the mailbox the customer's IT created for the
// assistant. Independent of the provider the user signed in to Catch with —
// a Google-primary executive can be given an Outlook assistant mailbox.
export type AssistantMailboxProvider = 'google' | 'microsoft'

export const assistantEmailService = {
  async getStatus(): Promise<AssistantEmailStatusResponse> {
    const response = await getAssistantEmailStatusApiV1AssistantEmailGet({
      throwOnError: true,
    });
    return response.data;
  },

  async setMailboxType(
    mailboxType: AssistantMailboxType,
  ): Promise<AssistantEmailStatusResponse> {
    const response = await setAssistantEmailApiV1AssistantEmailPut({
      body: { mailbox_type: mailboxType },
      throwOnError: true,
    });
    return response.data;
  },

  // Rename the hosted mailbox's handle. Surfaces the backend's validation /
  // conflict / rate-limit message (400 / 409 / 429) as the thrown Error message.
  async changeHandle(localPart: string): Promise<AssistantEmailStatusResponse> {
    try {
      const response = await changeHandleApiV1AssistantEmailHandlePut({
        body: { local_part: localPart },
        throwOnError: true,
      });
      return response.data;
    } catch (error: any) {
      const detail = error?.response?.data?.detail;
      if (detail && typeof detail === "string") {
        throw new Error(detail);
      }
      throw error;
    }
  },

  // Public (token-authenticated) endpoints backing the "guide your IT" page.
  async getDnsInstructions(token: string): Promise<DnsInstructionsResponse> {
    const response = await getDnsInstructionsApiV1AssistantEmailDnsInstructionsGet({
      query: { token },
      throwOnError: true,
    });
    return response.data;
  },

  async verifySubdomain(token: string): Promise<VerifyResponse> {
    const response = await verifySubdomainApiV1AssistantEmailVerifyPost({
      query: { token },
      throwOnError: true,
    });
    return response.data;
  },

  // Start the OAuth flow that connects a dedicated Google Workspace or
  // Microsoft 365 mailbox as the assistant's own address (the EXTERNAL
  // option). The callback persists the account and flips the identity
  // server-side. The provider is the user's to pick: it is a property of the
  // mailbox their IT created, not of the account they signed in to Catch with.
  async getConnectAssistantMailboxUrl(
    provider: AssistantMailboxProvider,
  ): Promise<string> {
    const authorize =
      provider === 'microsoft'
        ? connectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGet
        : connectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGet;
    const response = await authorize({ throwOnError: true });
    return response.data.authorization_url;
  },

  // Fully disconnect the assistant mailbox: deletes the connected account
  // (revoking our stored OAuth tokens) and, when it was the active identity,
  // reverts the assistant email to the plus address server-side. Same
  // endpoint the personal-inbox card uses — kind-agnostic by design.
  async disconnectAssistantMailbox(accountId: number): Promise<void> {
    await disconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDelete({
      path: { account_id: accountId },
      throwOnError: true,
    });
  },
};

export const statsService = {
  async getMyStats(): Promise<AssistantStatsResponse> {
    const response = await getMyStatsApiV1StatsMeGet({ throwOnError: true })
    return response.data
  },
}

export const referralService = {
  async getLink(): Promise<ReferralLinkResponse> {
    const response = await getReferralLinkApiV1ReferralLinkGet({ throwOnError: true })
    return response.data
  },

  async getStatus(): Promise<ReferralStatusResponse> {
    const response = await getReferralStatusApiV1ReferralStatusGet({ throwOnError: true })
    return response.data
  },

  async getSuggestions(): Promise<SuggestedContact[]> {
    const response = await getSuggestionsApiV1ReferralSuggestionsGet({
      throwOnError: true,
    })
    return response.data?.suggestions ?? []
  },

  async getNetwork(): Promise<ReferralNetworkResponse> {
    const response = await getNetworkApiV1ReferralNetworkGet({
      throwOnError: true,
    })
    return response.data
  },

  async dismissContact(email: string): Promise<void> {
    await dismissContactApiV1ReferralDismissPost({
      body: { email },
      throwOnError: true,
    })
  },

  async getInvites(): Promise<SentReferralInvite[]> {
    const response = await getInvitesApiV1ReferralInvitesGet({ throwOnError: true })
    return response.data?.invites ?? []
  },

  async getInvitePreview(program?: string): Promise<ReferralInvitePreviewResponse> {
    const response = await getInvitePreviewApiV1ReferralInvitePreviewGet({
      query: { program: program ?? null },
      throwOnError: true,
    })
    return response.data
  },

  async saveInviteTemplate(
    subject: string,
    body: string,
    program?: string,
  ): Promise<ReferralInviteTemplateRequest> {
    const response = await saveInviteTemplateApiV1ReferralInviteTemplatePut({
      body: { subject, body },
      query: { program: program ?? null },
      throwOnError: true,
    })
    return response.data
  },

  async resetInviteTemplate(
    program?: string,
  ): Promise<ReferralInvitePreviewResponse> {
    const response = await resetInviteTemplateApiV1ReferralInviteTemplateDelete({
      query: { program: program ?? null },
      throwOnError: true,
    })
    return response.data
  },

  async sendInvite(
    email: string,
    name?: string | null,
    source?: string | null,
  ): Promise<void> {
    await sendInviteApiV1ReferralInvitePost({
      body: { email, name: name ?? null, source: source ?? null },
      throwOnError: true,
    })
  },
}

// Automatic approvals (the JIT auto-approval mode). On by default since
// GET-12229, so this is primarily an off switch — and the reason one exists
// outside the assistant at all, since asking the assistant to stop acting on
// your behalf is a poor way to reach a setting you never chose. It is also the
// on switch for accounts from the concluded `auto-approval-default-new-users`
// holdout arm, whose signups never got the default in the first place.
//
// Both calls return the *verified* state rather than echoing the request: a
// central release group can keep the mode on for a user, and reporting a
// successful switch-off there would misdescribe what the assistant does next.
export const automaticApprovalsService = {
  async getStatus(): Promise<AutomaticApprovalsStatus> {
    const response = await automaticApprovalsStatusApiV1AutomaticApprovalsGet({
      throwOnError: true,
    });
    return response.data;
  },

  async setLevel(level: AutonomyLevel): Promise<AutomaticApprovalsStatus> {
    const response = await setAutonomyLevelApiV1AutomaticApprovalsLevelPut({
      body: { level },
      throwOnError: true,
    });
    return response.data;
  },
}

// Dedicated assistant phone number add-on ($15/mo): a private Twilio number
// for the assistant, billed like the personal-inbox add-on.
export const dedicatedNumberService = {
  async getStatus(): Promise<{
    available: boolean;
    phone_number?: string | null;
    monthly_price_formatted?: string | null;
    sms_capable?: boolean | null;
    texting_enabled?: boolean;
    country_choices?: CountryOption[];
  }> {
    const response = await dedicatedNumberStatusApiV1DedicatedNumberGet({
      throwOnError: true,
    });
    return response.data;
  },

  // Buys + wires + bills the number in one call. 402 = billing failed
  // (nothing provisioned), 409 = no inventory; both surface as thrown errors
  // for the card to render. `country` is the ISO code the user picked from
  // the pre-flighted choices; the backend silently buys a US number when it
  // can't honour it, so the response is the source of truth for what they got.
  // `areaCode` (US only) is searched as-is: sold out is a 409, never a
  // silent fallback to another area code.
  async provision(
    country?: string,
    areaCode?: string,
  ): Promise<{
    phone_number: string;
    billing: string;
    sms_capable: boolean;
    texting_enabled: boolean;
  }> {
    const response = await provisionNumberApiV1DedicatedNumberPost({
      body: {
        ...(country ? { country } : {}),
        ...(areaCode ? { area_code: areaCode } : {}),
      },
      throwOnError: true,
    });
    return response.data;
  },

  async release(): Promise<void> {
    await releaseNumberApiV1DedicatedNumberDelete({ throwOnError: true });
  },

  // The .vcf is fetched rather than linked: auth is a Bearer header, so a
  // plain <a href> navigation would arrive unauthenticated and 401. Asking
  // axios for a Blob keeps the bytes intact - the default JSON/text handling
  // would mangle the base64 photo line.
  //
  // The filename comes from the response rather than being rebuilt here: the
  // server names the file after the assistant's character, which this layer
  // has no reason to know.
  async downloadContactCard(): Promise<{ blob: Blob; filename: string }> {
    const response = await downloadContactCardApiV1DedicatedNumberContactCardGet({
      throwOnError: true,
      responseType: 'blob',
    });
    // RFC 5987's `filename*` first: the plain `filename` parameter is an
    // ASCII-only fallback, so reading it would save a Hebrew or CJK character
    // name as "????.vcf" - which is exactly what the server goes to the
    // trouble of encoding around.
    const disposition = String(response.headers?.['content-disposition'] ?? '');
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    const plain = /filename="?([^";]+)"?/.exec(disposition);
    let filename = plain?.[1] ?? 'assistant.vcf';
    if (encoded?.[1]) {
      try {
        filename = decodeURIComponent(encoded[1]);
      } catch {
        // Malformed percent-encoding: keep the ASCII fallback rather than
        // failing a download over the filename.
      }
    }
    return { blob: response.data as Blob, filename };
  },
};

// The owner's consent to their assistant texting their contacts from the
// shared guest line (GET-18126). Null until given.
export const contactTextingService = {
  async getConsent(): Promise<string | null> {
    const response = await getContactTextingConsentApiV1ContactTextingGet({ throwOnError: true });
    return response.data.consented_at ?? null;
  },

  async setConsent(consent: boolean): Promise<string | null> {
    const response = await setContactTextingConsentApiV1ContactTextingPut({
      body: { consent },
      throwOnError: true,
    });
    return response.data.consented_at ?? null;
  },
};

// The iOS Action Button shortcut's long-lived key. Read on every settings
// load rather than issued once - the backend derives it from the user's key
// version, so the same call is both "show me my key" and "show me the key my
// phone is already using".
export const shortcutService = {
  async getStatus(): Promise<ShortcutStatus> {
    const response = await shortcutStatusApiV1ShortcutGet({ throwOnError: true });
    return response.data;
  },

  // Rotating strands the copy on every device the user installed it on, so the
  // card asks first.
  async rotateKey(): Promise<string> {
    const response = await rotateKeyApiV1ShortcutKeyRotatePost({ throwOnError: true });
    return response.data.key;
  },
};
